import React from 'react';
import '../assets/styles/MunicipioLayout.scss';
import FomentoProductivo from '../components/comuna/FomentoProductivo';

const FomentoProductivoContainer = () => (
  <div className='MainMunicipio'>
    <FomentoProductivo />
  </div>
);
export default FomentoProductivoContainer;
